import __request__ from "routing/request";
export function list(status = "suggested", requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.aiagent/suggestions/event_definitions", null, { "status": status }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function apply(suggestionId, requestOptions) {
  return __request__("POST", `/plugins/org.graylog.plugins.aiagent/suggestions/event_definitions/${suggestionId}/apply`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function dismiss(suggestionId, requestOptions) {
  return __request__("POST", `/plugins/org.graylog.plugins.aiagent/suggestions/event_definitions/${suggestionId}/dismiss`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
